import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const parseTradeline = (tradeline, bureau = ALL) => {
  const dueAmount =
    tradeline?.amountPastDue > 0
      ? tradeline?.amountPastDue
      : tradeline?.currentBalance;

  const getNotificationMessage = () => {
    const actualDate = new Date();
    const evalDate = new Date(tradeline?.dateOpened);
    if (evalDate?.getFullYear() === actualDate.getFullYear()) {
      return <span>This account was recently added to your credit report</span>;
    } else {
      return '';
    }
  };

  const parsedTradeline = {
    creditor: tradeline?.creditor,
    dueAmount: dueAmount,
    dateOpened: tradeline?.dateOpened,
    bureauBalance: {
      transunion: {
        balance:
          bureau === TRANS_UNION
            ? dueAmount
            : tradeline?.bureauBalance?.transUnion,
      },
      equifax: {
        balance:
          bureau === EQUIFAX ? dueAmount : tradeline?.bureauBalance?.equifax,
      },
      experian: {
        balance:
          bureau === EXPERIAN ? dueAmount : tradeline?.bureauBalance?.experian,
      },
    },
    bgNotification: 'bgTradelineRed',
    notificationMessage: getNotificationMessage(),
    dontShowMessage: getNotificationMessage() === '' ? true : false,
  };

  return parsedTradeline;
};
